// impressum.component.ts
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-impressum',
  standalone: true,
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.css']
})
export class ImpressumComponent implements OnInit {

  constructor(
    private seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  currentYear = new Date().getFullYear();

  ngOnInit(): void {
    this.seoService.setTitle('Impressum');
    this.seoService.setDescription('Rechtliche Informationen zu unserer Webseite.');
    this.seoService.setCanonicalUrl()
  }
}